import { CreateCommentDto } from '@sr/dto';
import { commentsApi } from 'entities/comments/api';
import { Comments } from 'entities/comments';
import { extractNestJsErrorMessage } from 'shared/api/rtk-query';
import { CardPaperTitled } from 'shared/ui/card-paper';

export const PurchaseComments = ({ id }: { id: number; }) => {
  const { data, error, isLoading } = commentsApi.useFetchPurchaseCommentQuery(id);
  const [postComment] = commentsApi.usePostPurchaseCommentMutation();

  const handleAddComment = async (dto: CreateCommentDto) => {
    await postComment({ purchaseId: id, dto }).unwrap();
  };

  return (
    <CardPaperTitled title="Комментарии" sx={{ marginTop: 2 }}>
      <Comments
        comments={data}
        isLoading={isLoading}
        error={extractNestJsErrorMessage(error)}
        addComment={handleAddComment} />
    </CardPaperTitled>
  )
};
